import { PostServiceM3 } from "../../ConexionSQL/posts.service";

export class M3ReversoServ{


    
    public ProcesarReverso(PostServiceM3: PostServiceM3,sIDKatios: string, tdocActivo:string, ndocActivo:string,
        jData: any, funcionOK: Function, funcionError: Function) {
        PostServiceM3.postServiceHttpResFullM3("M3Reverso/Reversar/" + sIDKatios + "/" + ndocActivo + "/" + tdocActivo, jData).subscribe(resp => {
            //var oJson = JSON.parse(resp.json());
            
            funcionOK(resp);
        },
            err => {
                //this.enProceso = false;
                funcionError(err);
            }, );
    }

}